import * as React from 'react';
import { Credentials } from 'shared/models';

export type Props = {
    credentials: Credentials;
    onChangeCredentials: (credentials: Credentials) => void;
    onClickDelete: () => void;
};

export class CredentialsLine extends React.Component<Props, any> {
    providerSelect?: HTMLSelectElement | null;
    appIdInput?: HTMLInputElement | null;
    usernameInput?: HTMLInputElement | null;
    passwordInput?: HTMLInputElement | null;

    componentDidMount() {
        const { provider, appId, username, password } = this.props.credentials;
        this.providerSelect!.value = provider;
        this.appIdInput!.value = appId;
        this.usernameInput!.value = username;
        this.passwordInput!.value = password;
    }

    handleChange = () => {
        const { onChangeCredentials } = this.props;
        onChangeCredentials({
            provider: this.providerSelect!.value,
            appId: this.appIdInput!.value,
            username: this.usernameInput!.value,
            password: this.passwordInput!.value,
        });
    };

    setProviderRef = (e: HTMLSelectElement) => this.providerSelect = e;
    setAppIdRef = (e: HTMLInputElement) => this.appIdInput = e;
    setUsernameRef = (e: HTMLInputElement) => this.usernameInput = e;
    setPasswordRef = (e: HTMLInputElement) => this.passwordInput = e;

    render() {
        const { onClickDelete } = this.props;
        return (
            <tr>
                <td>
                    <select ref={ this.setProviderRef } onChange={ this.handleChange }>
                        <option value="thomson-reuters">Thomson Reuters</option>
                    </select>
                </td>
                <td>
                    <input type="text" ref={ this.setAppIdRef } onChange={ this.handleChange } maxLength={ 64 }/>
                </td>
                <td>
                    <input type="text" ref={ this.setUsernameRef } onChange={ this.handleChange } maxLength={ 64 }/>
                </td>
                <td>
                    <input type="text" ref={ this.setPasswordRef } onChange={ this.handleChange } maxLength={ 256 }/>
                </td>
                <td>
                    <button type="button" className="ui tiny icon basic button" onClick={ onClickDelete }>
                        <i className="delete icon"/>
                    </button>
                </td>
            </tr>
        );
    }
}
